import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},

	pre_insertar_sinliq(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.pre_insercion_liquid",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_poliza, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_poliza": p_poliza,
					"p_siniestro": p_siniestro
				  })
			})
	},

	recuperar_serv(p_email, p_usuario, p_codservicio, p_accion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_serv",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_codservicio": p_codservicio,
					"p_accion": p_accion
				  })
			})
	},

	recuperar_liquid(p_email, p_usuario, p_siniestro, p_veranulados) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_liquid",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_veranulados": p_veranulados
				  })
			})
	},

	recuperar_histprec(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.recuperar_histprec",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	
	crear_denuncio(p_email, p_usuario, p_nroordinario, p_nrosiniestro, p_sucursal, p_estado,
				   p_asistente, p_ejecutivo, p_poliza, p_producto, p_codafianzado, p_item,
				   p_endoso, p_codasegurado, p_codbeneficiario, p_monmtoasegurado, p_mtodenunciado,
				   p_mtvoconfig, p_feMotivo, p_idliquidador, p_servliquidador, p_ckconPreInforme, p_idcobrador, p_servcobrador,
				   p_sinobservacion, p_porccoaseguro, p_festconfig, p_nrocorrespondencia, p_fdenuncio
				   ) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_garsiniestros.crear_denuncio",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nroordinario": p_nroordinario, 
                    "p_nrosiniestro": p_nrosiniestro, 
                    "p_sucursal": p_sucursal,
                    "p_estado": p_estado,
                    "p_asistente": p_asistente,
                    "p_ejecutivo": p_ejecutivo,
                    "p_poliza": p_poliza,
                    "p_producto": p_producto,
                    "p_codafianzado": p_codafianzado,
                    "p_item": p_item,
                    "p_endoso": p_endoso,
                    "p_codasegurado": p_codasegurado,
                    "p_codbeneficiario": p_codbeneficiario,
                    "p_monmtoasegurado": p_monmtoasegurado,
                    "p_mtodenunciado": p_mtodenunciado,
                    "p_mtvoconfig": p_mtvoconfig,
                    "p_feMotivo": p_feMotivo,
                    "p_idliquidador": p_idliquidador,
					"p_servliquidador": p_servliquidador,
                    "p_ckconPreInforme": p_ckconPreInforme,
                    "p_idcobrador": p_idcobrador,
					"p_servcobrador": p_servcobrador,
                    "p_sinobservacion": p_sinobservacion,
                    "p_porccoaseguro": p_porccoaseguro,
                    "p_festconfig": p_festconfig,
					"p_nrocorrespondencia": p_nrocorrespondencia,
					"p_fdenuncio": p_fdenuncio
					
				  })
			})
	},

	actualizar_gestctrl(p_email, p_usuario, p_nrosiniestro, p_feenvcartaconf, p_fecenvinfliqase, p_coaseguro, p_partcubierta, p_nroacta,
						p_feestconfig, p_feemicheqtesore, p_porcimpaexcepc, p_ckdoccompletos, p_fedoccompletos, p_usdoccompletos,
					   	p_ckdocincompletos, p_fedocincompletos, p_usdocincompletos, p_cknoasigcobranza, p_fenoasigcobranza, p_usnoasigcobranza, 
						p_cknoasigliquidador, p_fenoasigliquidador, p_usnoasigliquidador, p_ckrecepcioninfor, p_ferecepcioninfor, p_usrecepcioninfor, 
						p_ckfecartacastigo, p_fecartacastigo, p_ckfeexcepcion, p_feexcepcion, p_fesiniestro, p_instanciaaut, p_mtoexcepcion, 
						p_observaciones, p_ckconpreinforme, p_mtodenunciado, p_mtvoconfig, p_feMotivo, p_idliquidador, p_servliquidador,  
						p_idcobrador, p_servcobrador, p_ckmarcaprec, p_femarcaprec, p_usumarcaprec, p_obsmarcaprec, p_sndobservacion, p_sndestado
				) {
		return axios
 			.post('spoc/modppentry', {
	 		"p_email": p_email,
	 		"p_metodo": "pkg_sinpp_garsiniestros.actualizar_gestctrl",
	 		"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_nrosiniestro": p_nrosiniestro, 
                "p_feenvcartaconf": p_feenvcartaconf, // Fecha Env. Carta Conf.
                "p_fecenvinfliqase": p_fecenvinfliqase, // Fec. Env. Informe Liq. Ase.
                "p_coaseguro": p_coaseguro, // Coaseguro (%)
                "p_partcubierta": p_partcubierta, // Parte Cubierta
                "p_nroacta": p_nroacta, // Número del Acta
				"p_feestconfig": p_feestconfig, // Fecha Est. Config.
                "p_feemicheqtesore": p_feemicheqtesore, // Fecha Emi. Cheq. Tesorería
                "p_porcimpaexcepc": p_porcimpaexcepc, // % Mto Impago Excepcionado
				"p_ckdoccompletos": p_ckdoccompletos, // Check List Doc. Completos
                "p_fedoccompletos": p_fedoccompletos, // Fecha Doc. Completos
                "p_usdoccompletos": p_usdoccompletos, // Usuario Doc. Completos
				"p_ckdocincompletos": p_ckdocincompletos, // Check List Doc. Incompletos
                "p_fedocincompletos": p_fedocincompletos, // Fecha Doc. Incompletos
                "p_usdocincompletos": p_usdocincompletos, // Usuario Doc. Incompletos
				"p_cknoasigcobranza": p_cknoasigcobranza, // Check List No Asig. Cobranza
                "p_fenoasigcobranza": p_fenoasigcobranza, // Fecha No Asig. Cobranza
                "p_usnoasigcobranza": p_usnoasigcobranza, // Usuario No Asig. Cobranza
				"p_cknoasigliquidador": p_cknoasigliquidador, // Check List No Asig. Liquidador
                "p_fenoasigliquidador": p_fenoasigliquidador, // Fecha No Asig. Liquidador
                "p_usnoasigliquidador": p_usnoasigliquidador, // Usuario No Asig. Liquidador
				"p_ckrecepcioninfor": p_ckrecepcioninfor, // Check List Recepción Informe
                "p_ferecepcioninfor": p_ferecepcioninfor, // Fecha Recepción Informe
				"p_usrecepcioninfor": p_usrecepcioninfor, // Usuario Recepción Informe
                "p_ckfecartacastigo": p_ckfecartacastigo, // Check List Carta Castigo
				"p_fecartacastigo": p_fecartacastigo, // Fecha Carta Castigo
                "p_ckfeexcepcion": p_ckfeexcepcion, // Check List Excepción
                "p_feexcepcion": p_feexcepcion, // Fecha Excepción
                "p_fesiniestro": p_fesiniestro, // Fecha Siniestro
                "p_instanciaaut": p_instanciaaut, // Instancia que Autorizó
                "p_mtoexcepcion": p_mtoexcepcion, // Monto Excepcionado
                "p_observaciones": p_observaciones,
				"p_ckconpreinforme": p_ckconpreinforme,
				"p_mtodenunciado": p_mtodenunciado,
				"p_mtvoconfig": p_mtvoconfig,
				"p_feMotivo": p_feMotivo,
				"p_idliquidador": p_idliquidador,
				"p_servliquidador": p_servliquidador,
				"p_idcobrador": p_idcobrador,
				"p_servcobrador": p_servcobrador,
				"p_ckmarcaprec": p_ckmarcaprec, // Check Marca Precautoria 
				"p_femarcaprec": p_femarcaprec, // Fecha Marca Precautoria
				"p_usumarcaprec": p_usumarcaprec, // Usuario Marca Precautoria
				"p_obsmarcaprec": p_obsmarcaprec, // Observaciones Marca Precautoria
				"p_sndobservacion": p_sndobservacion, // Observacion del siniestro
				"p_sndestado": p_sndestado // Estado del siniestro

	   })
 })
},

anular_liquid(p_email, p_usuario, p_siniestro, p_beneficiario, p_fecpago, p_mail_anu) {
	return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_garsiniestros.fnc_anular_liquid",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_siniestro": p_siniestro,
				"p_beneficiario": p_beneficiario,
				"p_fecpago": p_fecpago,
				"p_mail_anu": p_mail_anu,
			  })
		})
},






	

}